import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualRoleManagementPage } from './manual-role-management.page';

const routes: Routes = [
  {
    path: '',
    component: ManualRoleManagementPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualRoleManagementPageRoutingModule {}
